export default {
      id: "visage-usage",
      viewBox: "0 0 827.76 849",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#visage-usage",
      toString: function () {
        return this.url;
      }
    }